import React, { useEffect, useState, useCallback } from "react";
import "./AllMarkets.css";
import axios from "axios";
import BidPieChart from "../Dashboard/PieChart";
import Swal from "sweetalert2";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const marketImages = {
  Bullish: "bullish.png",
  Bearish: "bearish.png",
  "Nifty Prediction": "nifty-prediction.png",
  "Bank Nifty Prediction": "bank-nifty-prediction.png",
};

// --- Add this new SubMarketCard component ---
const SubMarketCard = ({ title, onClick }) => (
  <div className="sub-market-card" onClick={() => onClick(title)}>
    <h3>{title}</h3>
  </div>
);
const Card = ({ title, image, bidSlots, filledSlots, onClick }) => {
  return (
    <div className={`all-card`} onClick={() => onClick(title)}>
      <div className="all-card-content">
        <h2>{title}</h2>
        <div className="all-time-container">
          <div className="all-time-left">
            <p className="all-des">Filled Slots</p>
            <p className="all-time">{filledSlots}</p>
          </div>
          <div className="all-timer-line"></div>
          <div className="all-time-right">
            <p className="all-des">Bid Slots</p>
            <p className="all-time">{bidSlots}</p>
          </div>
        </div>
      </div>
      <div className={`all-card-icon ${title}`}>
        <img src={image} alt={title} className="all-icon" />
      </div>
    </div>
  );
};

const AllMarkets = () => {
  const [marketData, setMarketData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedMarket, setSelectedMarket] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedBidData, setSelectedBidData] = useState(null);
  const [filledSlotsData, setFilledSlotsData] = useState({});
  const userId = "556c3d52-e18d-11ef-9b7f-02fd6cfaf985";
  const [todayFormattedDate, setTodayFormattedDate] = useState();
  const [selectedBids, setSelectedBids] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editBidData, setEditBidData] = useState({
    bidType: "REGULAR",
    bidName: "",
    bidSlots: "",
    individualBidCount: "",
    imageUrl: "",
    minimumBidSlots: "",
    prizeMasterList: [], // NEW: array of prizes
  });


  // Add these new state variables
  const [isBankNiftySelected, setIsBankNiftySelected] = useState(false);
  const [selectedBankNiftyBidType, setSelectedBankNiftyBidType] = useState(null); // 'Master Bid', 'Weekly Bid', or 'Daily Bid'
  async function getFilledSlots() {
  const getFormattedDate = () => {
    const now = new Date();
    if (now.getHours() >= 16) {
      now.setDate(now.getDate() + 1); // Move to tomorrow if after 4 PM
    }
    const fullFormattedDate = now.toLocaleDateString("en-GB").split("/").join("-");
    const shortFormattedDate = now.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
    });
    return { fullFormattedDate, shortFormattedDate };
  };

  const { fullFormattedDate, shortFormattedDate } = getFormattedDate();
  setTodayFormattedDate(shortFormattedDate);

  const marketIds = [
    "6187ba91-e190-11ef-9b7f-02fd6cfaf985", // Bullish
    "877c5f82-e190-11ef-9b7f-02fd6cfaf985", // Bearish
    "97f37603-e190-11ef-9b7f-02fd6cfaf985", // Nifty
    "9f0c2c24-e190-11ef-9b7f-02fd6cfaf985"
  ];

  let slotsData = {};

  // 🌍 Regular markets
  for (const marketId of marketIds) {
    try {
      const response = await axios.get("https://prod-erp.nifty10.in/get/bidMarket", {
        params: {
          Date: fullFormattedDate,
          marketId,
          userId,
        },
      });

      const data = response.data.data || [];

      let totalFilledSlots = 0;
      let overallBidSlots = 0;

      data.forEach((market) => {
        if (market.active && market.freeBid) {
          overallBidSlots += market.bidSlots;
          totalFilledSlots += market.bidSlots - market.totalAvailableCount;
        }
      });

      slotsData[marketId] = {
        filledSlots: totalFilledSlots,
        bidSlots: overallBidSlots,
      };
    } catch (error) {
      console.error("Error fetching filled slots:", error);
      slotsData[marketId] = { filledSlots: 0, bidSlots: 0 };
    }
  }

  // 🏦 BANK NIFTY — fetch from Daily Bid API
  try {
    const response = await axios.get("https://prod-erp.nifty10.in/banknifty/daily");
    const data = response.data?.data || [];

    let totalFilled = 0;
    let totalSlots = 0;

    data.forEach((row) => {
      if (row.active) {
        totalFilled += row.filledSlots || 0;
        totalSlots += row.bidSlots || 0;
      }
    });

    slotsData["9f0c2c24-e190-11ef-9b7f-02fd6cfaf985"] = {
      filledSlots: totalFilled,
      bidSlots: totalSlots,
    };
  } catch (error) {
    console.error("Error fetching Bank Nifty daily bid data:", error);
    slotsData["9f0c2c24-e190-11ef-9b7f-02fd6cfaf985"] = { filledSlots: 0, bidSlots: 0 };
  }

  setFilledSlotsData(slotsData);
}



  useEffect(() => {
    getFilledSlots();
  }, [marketData]);

  useEffect(() => {
    const fetchMarketData = async () => {
      try {
        const response = await axios.get("https://prod-erp.nifty10.in/get/market");
        setMarketData(response.data.data || []);
      } catch (error) {
        console.error("Error fetching market data:", error);
        toast.error("Error fetching data.!");
      } finally {
        setLoading(false);
      }
    };
    fetchMarketData();
  }, []);
  // Replace the old handleMarketClick with this one
  const handleMarketClick = useCallback(async (marketId, marketName) => {
    // Reset states
    setSelectedMarket(marketName);
    setIsBankNiftySelected(false);
    setSelectedBankNiftyBidType(null);
    setTableData([]);
    setSelectedBids([]);
    setSelectAll(false);
    setSelectedRow(null);
    setIsActive(false);

    // Special handling for Bank Nifty
    if (marketName === "Bank Nifty Prediction") {
      setIsBankNiftySelected(true);
      return; // Stop execution to show sub-market cards
    }

    setDataLoading(true);
    setErrorMsg("");

    try {
      const data = await getMarketData(marketId);
      if (data.length === 0) {
        setErrorMsg("No data available for today.");
      }
      const sortedData = data.sort((a, b) => Number(a.bidName) - Number(b.bidName));
      const filteredData = sortedData.filter((item) => item.freeBid === true);
      setTableData(filteredData);
    } catch (error) {
      setErrorMsg("Failed to load data.");
      console.error("Error fetching table data:", error);
      toast.error("Error fetching data.!");
    } finally {
      setDataLoading(false);
    }
  }, []);

  // Add this new function right after handleMarketClick
const handleSubMarketClick = async (bidType) => {
  setSelectedBankNiftyBidType(bidType);
  setDataLoading(true);
  setErrorMsg("");

  let apiUrl = "";

  // 🔁 Now we call our own backend route instead of the external one
  if (bidType === "Master Bid") {
    apiUrl = "https://prod-erp.nifty10.in/banknifty/master";
  } else if (bidType === "Weekly Bid") {
    apiUrl = "https://prod-erp.nifty10.in/banknifty/weekly";
  } else if (bidType === "Daily Bid") {
    apiUrl = "https://prod-erp.nifty10.in/banknifty/daily";
  }

  try {
    const response = await axios.get(apiUrl);
    const data = response.data?.data || [];

    if (!data.length) {
      setErrorMsg("No active data available for this bid type.");
      setTableData([]);
      return;
    }

    // ✅ We already transform data in backend, so you can set directly
    setTableData(data);
    setErrorMsg("");
  } catch (error) {
    console.error("Error fetching Bank Nifty bids:", error);
    setErrorMsg("Failed to load data.");
    toast.error("Error fetching data!");
  } finally {
    setDataLoading(false);
  }
};


  // Update prize field
  const handlePrizeChange = (index, field, value) => {
    const updated = [...editBidData.prizeMasterList];
    updated[index] = { ...updated[index], [field]: value };
    setEditBidData(prev => ({ ...prev, prizeMasterList: updated }));
  };

  // Delete prize row
  const handleDeletePrize = (index) => {
    const updated = editBidData.prizeMasterList.filter((_, i) => i !== index);
    setEditBidData(prev => ({ ...prev, prizeMasterList: updated }));
  };

  // Add new prize row
  const handleAddPrize = () => {
    setEditBidData(prev => ({
      ...prev,
      prizeMasterList: [
        ...prev.prizeMasterList,
        { eligibleUserCount: 0, giftName: "", prizeValue: 0, img: "" }
      ]
    }));
  };

  useEffect(() => {
    if (marketData.length > 0 && !selectedMarket) {
      const bullishMarket = marketData.find((m) =>
        m.marketName.toLowerCase().includes("bullish")
      );
      if (bullishMarket) {
        handleMarketClick(bullishMarket.marketId, bullishMarket.marketName);
      }
    }
  }, [marketData, selectedMarket, handleMarketClick]);


  const getMarketData = async (marketId) => {
    setDataLoading(true);
    setErrorMsg("");

    try {
      const getFormattedDate = () => {
        const now = new Date();
        if (now.getHours() >= 16) {
          now.setDate(now.getDate() + 1); // Move to tomorrow if after 4 PM
        }
        return now.toLocaleDateString("en-GB").split("/").join("-");
      };
      const fullFormattedDate = getFormattedDate();


      const response = await axios.get("https://prod-erp.nifty10.in/get/bidMarket", {
        params: {
          Date: fullFormattedDate,
          marketId: marketId,
          userId: userId, // make sure userId is defined in the scope
        },
      });

      const data = response.data.data || [];
      if (!data.length) setErrorMsg("No data available for today.");
      return data;
    } catch (error) {
      setErrorMsg("Failed to load data.");
      console.error("Error fetching market data:", error);
      toast.error("Error fetching data.!");
      return [];
    } finally {
      setDataLoading(false);
    }
  };




  // Automatically select the row with bidName "19" for bullish and bearish markets
  // REPLACE this existing useEffect block...
  useEffect(() => {
    if (tableData.length > 0) {
      // For Bullish/Bearish, select "19"
      if (
        selectedMarket &&
        (selectedMarket.toLowerCase().includes("bullish") ||
          selectedMarket.toLowerCase().includes("bearish"))
      ) {
        const defaultRow = tableData.find((row) => row.bidName === "19");
        if (defaultRow) {
          rowSelected(defaultRow.dayWiseBidId, defaultRow.marketId);
        }
        // For any other table, select the first row
      } else {
        const firstRow = tableData[0];
        if (firstRow) {
          rowSelected(firstRow.dayWiseBidId, firstRow.marketId)
        }
      }
    }
  }, [selectedMarket, tableData]);


  // ...WITH this new, simplified version:
  useEffect(() => {
    if (tableData.length > 0) {
      const firstRow = tableData[0];
      if (firstRow) {
        if (isBankNiftySelected) {
          // Only set selectedBidData locally - don't call ERP API
          setSelectedBidData({
            bidName: firstRow.bidName,
            dayWiseBidId: firstRow.dayWiseBidId,
            bidSlots: firstRow.bidSlots,
            totalAvailableCount: firstRow.individualBidCount,
            percentage: 0,
            completedBids: 0,
            marketName: "Bank Nifty Master Bid"
          });
          setSelectedRow(firstRow.dayWiseBidId);
          setIsActive(false); // prevent pie chart API fetch
        } else {
          // normal markets - safe
          rowSelected(firstRow.dayWiseBidId, firstRow.marketId);
        }
      }
    }
  }, [tableData, isBankNiftySelected]);


  const rowSelected = async (id, marketId) => {
    setIsActive(true);
    setSelectedRow(id);
    setErrorMsg("");

    try {
      // Skip API call if Bank Nifty or selected bid type is Master Bid
      if (
  isBankNiftySelected &&
  ["Master Bid", "Weekly Bid", "Daily Bid"].includes(selectedBankNiftyBidType)
) {
  const selectedBid = tableData.find(
    (bid) => bid.dayWiseBidId === id && bid.marketId === marketId
  );

  if (selectedBid) {
    const { bidName, bidSlots, dayWiseBidId, totalAvailableCount, marketName } = selectedBid;
    const completedBids = bidSlots - totalAvailableCount;
    const percentage =
      bidSlots > 0 ? ((completedBids / bidSlots) * 100).toFixed(2) : "0.00";

    setSelectedBidData({
      bidName,
      dayWiseBidId,
      bidSlots,
      totalAvailableCount,
      marketName,
      percentage,
      completedBids,
    });
  } else {
    setErrorMsg("Bid not found in local data.");
  }

  return; // ✅ stop here, skip API call
}

      // Format date for API
      const getFormattedDate = () => {
        const now = new Date();
        if (now.getHours() >= 16) {
          now.setDate(now.getDate() + 1); // Move to tomorrow if after 4 PM
        }
        return now.toLocaleDateString("en-GB").split("/").join("-");
      };
      const fullFormattedDate = getFormattedDate();

      // API call for other markets
      const response = await axios.get(`https://prod-erp.nifty10.in/get/bidMarket`, {
        params: {
          Date: fullFormattedDate,
          marketId: marketId,
          userId: userId,
        },
      });

      const data = response.data.data || [];
      if (!data.length) {
        setErrorMsg("No data available for today.");
        return;
      }

      const selectedBid = tableData.find(
        (bid) => bid.dayWiseBidId === id && bid.marketId === marketId
      );

      if (selectedBid) {
        const { bidName, bidSlots, dayWiseBidId, totalAvailableCount, marketName } = selectedBid;
        const completedBids = bidSlots - totalAvailableCount;
        const percentage = bidSlots > 0 ? ((completedBids / bidSlots) * 100).toFixed(2) : "0.00";

        setSelectedBidData({ bidName, dayWiseBidId, bidSlots, totalAvailableCount, marketName, percentage, completedBids });
      } else {
        console.log("Bid not found in local data.");
      }

    } catch (error) {
      console.error("Error fetching data:", error);
      setErrorMsg("Failed to load data.");
      toast.error("Error fetching data!");
    }
  };



  const changeActiveStatus = async (id, prevStatus) => {
    try {
      const newStatus = !prevStatus;

      const response = await fetch(
        `https://prod-erp.nifty10.in/change/status?dayWiseBidId=${id}&status=${newStatus}`,
        { method: "GET" }
      );

      if (!response.ok) {
        throw new Error("Failed to update status");
      }

      setTableData((prevTable) =>
        prevTable?.map((row) =>
          row.dayWiseBidId === id ? { ...row, active: newStatus } : row
        ) || []
      );

      if (selectedMarket?.bidData) {
        setSelectedMarket((prevMarket) => ({
          ...prevMarket,
          bidData:
            prevMarket.bidData?.map((row) =>
              row.dayWiseBidId === id ? { ...row, active: newStatus } : row
            ) || [],
        }));
      }

      setMarketData((prevMarkets) =>
        prevMarkets?.map((market) =>
          market.id === selectedMarket?.id
            ? {
              ...market,
              bidData:
                market.bidData?.map((row) =>
                  row.dayWiseBidId === id ? { ...row, active: newStatus } : row
                ) || [],
            }
            : market
        ) || []
      );
    } catch (error) {
      toast.error("Error changing status. Please try again.");
    }
  };


  const onClickStatus = (id, prevStatus) => {
    const selectedBid = tableData.find((bid) => bid.dayWiseBidId === id);

    if (!selectedBid) {
      toast.error("Bid not found.");
      return;
    }

    const filledSlots = selectedBid.bidSlots - selectedBid.totalAvailableCount;

    if (filledSlots > 0) {
      toast.error("Cannot deactivate bid with filled slots.");
      return;
    }

    const newStatus = !prevStatus;
    const statusText = prevStatus ? "Active" : "Inactive";
    const newStatusText = newStatus ? "Active" : "Inactive";

    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to change the status from ${statusText} to ${newStatusText}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        changeActiveStatus(id, prevStatus);
        Swal.fire({
          title: "Changed!",
          text: `Status changed successfully to ${newStatusText}.`,
          icon: "success",
        });
      } else {
        Swal.fire({
          title: "Cancelled",
          text: "Status not changed.",
          icon: "error",
        });
      }
    });
  };
  const handleBulkDeactivate = async () => {
    const bidsToDeactivate = tableData.filter(row =>
      selectedBids.includes(row.dayWiseBidId) && row.active
    );

    const bidsWithFilledSlots = bidsToDeactivate.filter(row =>
      (row.bidSlots - row.totalAvailableCount) > 0
    );

    if (bidsWithFilledSlots.length > 0) {
      toast.error("Some selected bids have filled slots. Cannot deactivate.");
      return;
    }

    const confirmed = await Swal.fire({
      title: "Are you sure?",
      text: `Do you want to deactivate ${bidsToDeactivate.length} bids?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, deactivate",
      cancelButtonText: "No",
      reverseButtons: true
    });

    if (confirmed.isConfirmed) {
      for (const bid of bidsToDeactivate) {
        await changeActiveStatus(bid.dayWiseBidId, true); // true = was active
      }
      toast.success("Selected bids deactivated successfully.");
      setSelectedBids([]);
      setSelectAll(false);
    }
  };
  const handleEditClick = (row) => {
    // Pre-fill form fields with row data
    setEditBidData({
      bidType: row.bidType || "REGULAR",
      bidName: row.bidName || "",
      bidSlots: row.bidSlots || "",
      individualBidCount: row.individualBidCount || "",
      imageUrl: row.imageUrl || "",
      bidId: row.dayWiseBidId,
      minimumBidSlots: row.minimumBidSlots,
      prizeMasterList: row.prizeMasterList || [], // NEW
    });
    setIsEditing(true);
  };
  const handleEditSubmit = async (e) => {
  e.preventDefault();
  try {
    const payload = {
      active: true,
      bidId: editBidData.bidId,
      bidName: editBidData.bidName,
      minimumBidSlots: editBidData.minimumBidSlots,
      bidSlots: Number(editBidData.bidSlots),
      individualBidCount: Number(editBidData.individualBidCount),
      bidType: editBidData.bidType,
      imageUrl: editBidData.imageUrl,
      frequency: "WEEKLY",
      prizeMasterList: editBidData.prizeMasterList.map((prize) => ({
        eligibleUserCount: Number(prize.eligibleUserCount),
        giftName: prize.giftName,
        prizeValue: Number(prize.prizeValue),
        img: prize.img,
      })),
    };

    // ✅ Call your backend route instead of direct API
    const response = await axios.post(
      `https://prod-erp.nifty10.in/banknifty/update-bid`,
      payload
    );

    if (response.status === 200) {
      toast.success("Bid updated successfully!");
      setIsEditing(false);
      handleSubMarketClick("Master Bid"); // refresh table
    } else {
      toast.error("Failed to update bid.");
    }
  } catch (error) {
    console.error("Error updating bid:", error);
    toast.error("Error updating bid.");
  }
};


  // Replace the existing showTable and tableHeader lines with these:
  const showBankNiftyContent = isBankNiftySelected && selectedBankNiftyBidType;
  const showTable = (selectedMarket && !isBankNiftySelected) || showBankNiftyContent;
  const [displayDate, setDisplayDate] = useState(todayFormattedDate);

useEffect(() => {
  if (isBankNiftySelected) {
    if (selectedBankNiftyBidType === "Master Bid") {
      setDisplayDate(""); // no date
    } else if (selectedBankNiftyBidType === "Weekly Bid" && tableData.length > 0) {
      const { weekStartDate, weekEndDate } = tableData[0];
      if (weekStartDate && weekEndDate) {
        const formatDate = (dateStr, addOneDay = false) => {
          const [year, month, day] = dateStr.split("-");
          const date = new Date(`${year}-${month}-${day}`);
          if (addOneDay) {
            date.setDate(date.getDate() + 1);
          }
          return date.toLocaleDateString("en-GB", { day: "2-digit", month: "short" });
        };
        // 🗓 bump the start date by +1 day
        setDisplayDate(`${formatDate(weekStartDate, true)} - ${formatDate(weekEndDate)}`);
      }
    } else if (selectedBankNiftyBidType === "Daily Bid") {
      setDisplayDate(todayFormattedDate);
    }
  } else {
    setDisplayDate(todayFormattedDate);
  }
}, [isBankNiftySelected, selectedBankNiftyBidType, tableData, todayFormattedDate]);


const tableHeader = isBankNiftySelected ? selectedBankNiftyBidType : selectedMarket;

  // const tableHeader = isBankNiftySelected ? selectedBankNiftyBidType : selectedMarket;
  // Replace your entire return block with this
  // Replace your entire return block with this
  return (
    <div className="all-markets-bg-container">
      <div className="all-cards-container">
        {loading ? (
          <p>Loading market data...</p>
        ) : (
          marketData.map((market) => (
            <Card
              key={market.marketId}
              title={market.marketName}
              image={marketImages[market.marketName] || "default.png"}
              filledSlots={filledSlotsData?.[market.marketId]?.filledSlots || 0}
              bidSlots={filledSlotsData?.[market.marketId]?.bidSlots || 0}
              onClick={() => handleMarketClick(market.marketId, market.marketName)}
            />
          ))
        )}
        <ToastContainer position="top-right" style={{ marginTop: "65px" }} />
      </div>

      {/* Bank Nifty Sub-Market Cards */}
      {isBankNiftySelected && (
        <div className="sub-market-container">
          <h2 className="sub-market-title">Select a Bid Type for Bank Nifty</h2>
          <div className="sub-market-cards-wrapper">
            <SubMarketCard title="Master Bid" onClick={handleSubMarketClick} />
            <SubMarketCard title="Weekly Bid" onClick={handleSubMarketClick} />
            <SubMarketCard title="Daily Bid" onClick={handleSubMarketClick} />
          </div>
        </div>
      )}

      {/* Table */}
      {showTable && (
        <div className="markets-table-container">
          <div className={`popup-heading ${selectedMarket}`}>
            {!isBankNiftySelected && (
            <div className="allmarkets-header">{tableHeader} ({todayFormattedDate})</div>)}
            {isBankNiftySelected && (
            <div className="allmarkets-header">
  {tableHeader}
  {displayDate ? ` (${displayDate})` : ""}
</div>)}
            {!isBankNiftySelected && (
              <button
                onClick={handleBulkDeactivate}
                className="all-inactive-btn"
                disabled={selectedBids.length === 0}
              >
                Inactive Selected
              </button>
            )}
          </div>

          <div className="table-container1">
            {dataLoading ? (
              <p className="loading-message">Loading data, please wait...</p>
            ) : tableData.length > 0 ? (
              <table className="admin-table">
                <thead>
                  <tr>
                    {isBankNiftySelected ? (
                      <>

                        <th className="bank-table">Bid Name</th>
                        <th className="bank-table">Bid Slots</th>
                        <th className="bank-table">Individual Bid Slots</th>
                        {selectedBankNiftyBidType === "Master Bid" && (
                          <th className="bank-table">prize Model</th>
                        )}
                        {selectedBankNiftyBidType === "Weekly Bid" && (
                          <th className="bank-table">Total Worth</th>
                        )}
                        {selectedBankNiftyBidType === "Weekly Bid" && (
                          <th className="bank-table">Users Joined</th>
                        )}
                        {selectedBankNiftyBidType === "Daily Bid" && (
                          <th className="bank-table">Filled Slots</th>
                        )}
                        <th className="bank-table">Minimum Bid Slots</th>
                        <th className="bank-table">Status</th>

                        {selectedBankNiftyBidType === "Master Bid" && (
                          <th className="bank-table">Action</th>
                        )}



                      </>
                    ) : (
                      <>
                        <th>
                          <input
                            type="checkbox"
                            checked={selectAll}
                            onChange={() => {
                              const allIds = tableData.map(row => row.dayWiseBidId);
                              setSelectAll(!selectAll);
                              setSelectedBids(!selectAll ? allIds : []);
                            }}
                          />
                        </th>
                        <th>Index</th>
                        <th>Value</th>
                        <th>Slots</th>
                        <th>Prize Pool</th>
                        <th>Status</th>
                        <th>First Prize</th>
                        <th></th>
                      </>
                    )}
                  </tr>
                </thead>

                <tbody>
                  {tableData.map((row, index) => {
                    const isChecked = selectedBids.includes(row.dayWiseBidId);
                    return (
                      <tr
                        key={row.dayWiseBidId}
                        onClick={() => rowSelected(row.dayWiseBidId, row.marketId)}
                        className={selectedRow === row.dayWiseBidId ? "row-active" : ""}
                      >
                        {isBankNiftySelected ? (
                          <>
                            {/* <td>{index + 1}</td> */}
                            <td className="bank-row">{row.bidName}</td>
                            <td className="bank-row">{row.bidSlots}</td>
                            <td className="bank-row">{row.individualBidCount}</td>
                            {selectedBankNiftyBidType === "Master Bid" && (
                              <td className="bank-row">{row.prizeModel}</td>)}
                            {selectedBankNiftyBidType === "Weekly Bid" && (
                              <td className="bank-row">{row.totalWorth}</td>)}
                              {selectedBankNiftyBidType === "Weekly Bid" && (
                              <td className="bank-row">{row.topUserCount}</td>)}
                            {selectedBankNiftyBidType === "Daily Bid" && (
                              <td className="bank-row">{row.filledSlots}</td>)}
                            <td className="bank-row">{row.minimumBidSlots}</td>
                            <td
                              // onClick={(e) => {
                              //   e.stopPropagation();
                              //   onClickStatus(row.dayWiseBidId, row.active);
                              // }}
                              className="market-table-status status-active bank-row"
                            >
                              {row.active ? "✅ Active" : "❌ Inactive"}
                            </td>
                            {selectedBankNiftyBidType === "Master Bid" && (
                              <td
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleEditClick(row);
                                }}
                                className="edit-icon-cell bank-row"
                              >
                                <i className="fa-regular fa-pen-to-square"></i>
                              </td>
                            )}

                          </>
                        ) : (
                          <>
                            <td>
                              <input
                                type="checkbox"
                                checked={isChecked}
                                onChange={(e) => {
                                  e.stopPropagation();
                                  const id = row.dayWiseBidId;
                                  setSelectedBids((prev) =>
                                    e.target.checked
                                      ? [...prev, id]
                                      : prev.filter(bidId => bidId !== id)
                                  );
                                }}
                              />
                            </td>
                            <td>{index + 1}</td>
                            <td>{row.bidName}</td>
                            <td>{row.bidSlots}</td>
                            <td>{row.poolPrize}</td>
                            <td
                              onClick={(e) => {
                                e.stopPropagation();
                                onClickStatus(row.dayWiseBidId, row.active);
                              }}
                              className="market-table-status status-active"
                            >
                              {row.active ? "✅ Active" : "❌ Inactive"}
                            </td>
                            <td>{row.firstPrize}</td>
                            <td></td>
                          </>
                        )}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            ) : (
              <p className="error-msg">{errorMsg}</p>
            )}
          </div>

          {/* Pie Chart */}
          {isActive && selectedBidData && !isBankNiftySelected && (
            <BidPieChart {...selectedBidData} />
          )}

        </div>
      )}
      {isEditing && (
        <div className="modal-overlay" onClick={() => setIsEditing(false)}>
          <div
            className="modal-container"
            onClick={(e) => e.stopPropagation()} // prevent modal close when clicking inside
          >
            <h2 className="modal-title">Edit Master Bid</h2>
            <form onSubmit={handleEditSubmit} className="nifty-bid-form-container">
              {/* Row 1: Bid Type */}
              <div className="nifty-bid-form-group">
                <label htmlFor="bidType">Bid Type</label>
                <select
                  id="bidType"
                  className="nifty-bid-form-select"
                  value={editBidData.bidType}
                  onChange={(e) => setEditBidData({ ...editBidData, bidType: e.target.value })}
                >
                  <option value="REGULAR">Regular</option>
                  <option value="SPECIAL">Special</option>
                </select>
              </div>

              {/* Row 2: Bid Name & Slots */}
              <div className="nifty-bid-form-row">
                <div className="nifty-bid-form-group">
                  <label htmlFor="bidName">Bid Name</label>
                  <input
                    type="text"
                    id="bidName"
                    className="nifty-bid-form-input"
                    placeholder="e.g., Special Bid"
                    value={editBidData.bidName}
                    onChange={(e) => setEditBidData({ ...editBidData, bidName: e.target.value })}
                  />
                </div>
                <div className="nifty-bid-form-group">
                  <label htmlFor="bidSlots">Bid Slots</label>
                  <input
                    type="number"
                    id="bidSlots"
                    className="nifty-bid-form-input"
                    placeholder="-1 for infinity"
                    value={editBidData.bidSlots}
                    onChange={(e) => setEditBidData({ ...editBidData, bidSlots: e.target.value })}
                  />
                </div>
              </div>

              {/* Row 3: Individual Bid Count & Image URL */}
              <div className="nifty-bid-form-row">
                <div className="nifty-bid-form-group">
                  <label htmlFor="individualBidCount">Individual Bid Count</label>
                  <input
                    type="number"
                    id="individualBidCount"
                    className="nifty-bid-form-input"
                    placeholder="e.g., 2"
                    value={editBidData.individualBidCount}
                    onChange={(e) =>
                      setEditBidData({
                        ...editBidData,
                        individualBidCount: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="nifty-bid-form-group">
                  <label htmlFor="imageUrl">Image URL</label>
                  <input
                    type="text"
                    id="imageUrl"
                    className="nifty-bid-form-input"
                    placeholder="https://..."
                    value={editBidData.imageUrl || ""}
                    onChange={(e) => setEditBidData({ ...editBidData, imageUrl: e.target.value })}
                  />
                </div>
              </div>
              <div className="nifty-bid-form-row">
                <div className="nifty-bid-form-group">
                  <label htmlFor="minimumBidSlots">minimum Bid Slots</label>
                  <input
                    type="number"
                    id="minimumBidSlots"
                    className="nifty-bid-form-input"
                    placeholder="e.g., 2"
                    value={editBidData.minimumBidSlots}
                    onChange={(e) =>
                      setEditBidData({
                        ...editBidData,
                        minimumBidSlots: e.target.value,
                      })
                    }
                  />
                </div>

              </div>

              {/* Prize Master List Table */}
              <div className="nifty-bid-prize-master-container">
                <h3>Prize Master List</h3>
                <table className="nifty-bid-prize-master-table">
                  <thead>
                    <tr>
                      <th>No. of Users</th>
                      <th>Name</th>
                      <th>Value</th>
                      <th>Image URL</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {editBidData.prizeMasterList.map((prize, index) => (
                      <tr key={index}>
                        <td>
                          <input
                            type="number"
                            value={prize.eligibleUserCount}
                            onChange={(e) => handlePrizeChange(index, "eligibleUserCount", e.target.value)}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            value={prize.giftName}
                            onChange={(e) => handlePrizeChange(index, "giftName", e.target.value)}
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            value={prize.prizeValue}
                            onChange={(e) => handlePrizeChange(index, "prizeValue", e.target.value)}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            value={prize.img}
                            onChange={(e) => handlePrizeChange(index, "img", e.target.value)}
                          />
                        </td>
                        <td>
                          <button
                            type="button"
                            className="nifty-bid-delete-btn"
                            onClick={() => handleDeletePrize(index)}
                          >
                            &times;
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <button type="button" className="nifty-bid-add-btn" onClick={handleAddPrize}>
                  + Add Prize
                </button>
              </div>

              {/* Form Action Buttons */}
              <div className="nifty-bid-modal-actions">
                <button
                  type="button"
                  className="nifty-bid-cancel-btn"
                  onClick={() => setIsEditing(false)}
                >
                  Cancel
                </button>
                <button type="submit" className="nifty-bid-submit-btn">
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

    </div>
  );

};

export default AllMarkets;